<template>
  <v-card>
    <v-container fluid grid-list-md>
      <v-layout row wrap align-start justify-center >
        <v-flex xs12>
          <h2>Southview PTO Executive Committee Members</h2>
          <v-divider></v-divider>
        </v-flex>
        <v-flex xs12 sm6>
          <v-card>
            
            <v-list two-line dense>
              <v-list-item v-for="member in execCol1" :key="member.name">
                <v-list-item-content>
                  <v-list-item-title>{{member.title}}</v-list-item-title>
                  <v-list-item-subtitle >{{member.name}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>{{ member.phone }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 >
          <v-card>
            <v-list two-line dense>
              <v-list-item v-for="member in execCol2" :key="member.name">
                <v-list-item-content>
                  <v-list-item-title>{{member.title}}</v-list-item-title>
                  <v-list-item-subtitle >{{member.name}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>{{ member.phone }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-start justify-center >
        <v-flex xs12 >
          <h2>Southview PTO Committee Chairs</h2>
          <v-divider></v-divider>
        </v-flex>
        <v-flex xs12 v-for="(committee, committeeName) in chairs" :key="committeeName">

          <v-card >
            <v-list two-line dense subheader>
              <v-subheader ><h3>{{committeeName}}</h3></v-subheader>
              <v-list-item v-for="member in committee" :key="`${committeeName}-${member.name}`">
                <v-list-item-content>
                  <v-list-item-title>{{member.name}}</v-list-item-title>
                  <v-list-item-subtitle>{{member.email}} </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content >{{ member.phone }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>

  <!-- <v-card>
    <v-card-title><h1>Southview PTO Committee Chairs</h1></v-card-title>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex  v-for="(cls, teacher) in grade.classes" :key="teacher" xs12 sm6 md4 lg3>
          <v-card>
            <v-card-title><h3>{{teacher}}</h3></v-card-title>
            
            <v-divider></v-divider>
            <v-list dense>
              <v-list-item v-for="student in cls.students" :key="student.first + student.last">
                <v-list-item-content>{{student.first}} {{student.last}}</v-list-item-content>
                <v-list-item-content>{{ student.home_phone }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card> -->
        
  
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'PTOByCommittee',
  data()  {
    return {
      execCommittee: [],
      members: [],
      committeeList: []
    }
  },
  mounted: function() {
    //2 queries to make it easy?  yes
    firebase.firestore().collection('pto').orderBy('name').get().then((snapshot) => {
      snapshot.forEach((doc) => {
        //console.log(doc.data());
        this.members.push(doc.data());
      });
    });




    firebase.firestore().collection('admin').doc('pto_config').get().then((doc) => {
      let pto_config = doc.data();
      this.committeeList = pto_config.committes;
    });

    firebase.firestore().collection('pto').where('executiveCommittee', '==', true).orderBy('title').get().then((snapshot) => {
      snapshot.forEach((doc) => {
       // console.log(doc.data());
        this.execCommittee.push(doc.data());
      });
    });
  },
  computed: {
    chairs() {
      let chairs = {}
      for(let i=0;i<this.committeeList.length;i++) {
        chairs[this.committeeList[i]] = [];
        //chairs[this.committeeList[i]].members = [];
      }
      
      


      
      this.members.forEach((member) => {
        for(let i=0;i<member.committees.length;i++) {
          if(chairs.hasOwnProperty(member.committees[i])) {
            chairs[member.committees[i]].push(member);
          }  
        }
      });
      return chairs;
     
    },
    execCol1() {
      return this.execCommittee.slice(0,this.execCommittee.length/2+1);
    },
    execCol2() {
      return this.execCommittee.slice(this.execCommittee.length/2+1);
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

</style>
